export var useSelectAllCheckbox = function (filterMap, currentCheckbox, selectAllCheckboxName) {
    var currentCheckboxValue = filterMap[currentCheckbox];
    var selectAllValue = filterMap[selectAllCheckboxName];
    var isAllCheckboxSelected = currentCheckbox === selectAllCheckboxName;
    var allCheckboxSelectedMap = {};
    // Auto-select the other options when "all" option is selected
    if (isAllCheckboxSelected) {
        for (var _i = 0, _a = Object.keys(filterMap); _i < _a.length; _i++) {
            var key = _a[_i];
            allCheckboxSelectedMap[key] = !selectAllValue;
        }
    }
    // uncheck "all option" if any other option is pressed
    else {
        allCheckboxSelectedMap[selectAllCheckboxName] = false;
        allCheckboxSelectedMap[currentCheckbox] = !currentCheckboxValue;
    }
    return allCheckboxSelectedMap;
};
